import { NotificationType } from '@frontend-types/domain'
import { App } from 'antd'
import { NotificationPlacement } from 'antd/lib/notification/interface'

import { NOTIFICATION_STATUS } from '@shared/const'

export const useNotify = () => {
  const { notification } = App.useApp()

  return ({
    title = '',
    type = NOTIFICATION_STATUS.info,
    message,
    duration = 6,
    placement = 'bottomLeft',
    key,
  }: {
    title?: string
    type?: NotificationType
    message: string | React.ReactNode
    duration?: number
    placement?: NotificationPlacement
    key?: string
  }) => {
    notification[type]({
      title,
      description: message,
      duration,
      placement,
      key,
    })
  }
}
